import SectionNav from 'components/organisms/SectionNav/SectionNav';
import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { integrationsSidebarConfig } from 'navigation/IntegrationsNavigation/IntegrationsNavigation.constants';
import styles from './Integrations.module.scss';

/**
 * Shell for the third-party integration dashboards: topics on the left, the
 * selected integration beside them.
 */
const Integrations: FC = () => (
  <div className={styles.layout}>
    <SectionNav
      heading="Integrations"
      items={integrationsSidebarConfig.map(route => ({
        title: route.title,
        path: route.path,
      }))}
    />
    <div className={styles.content}>
      <Outlet />
    </div>
  </div>
);

export default Integrations;
